<app-breadcrumbs></app-breadcrumbs>
<div class="page-wrapper">
  <div class="spinner" *ngIf="isLoading; else wellbeingPage"></div>
  <ng-template #wellbeingPage>
    <section>
      <div class="title-background"></div>
      <div class="content-wrapper title">
        <h1>Student wellbeing</h1>
      </div>
      <div class="content-wrapper pos-rel-md">
        <app-page-retrieval-error
          *ngIf="pageRetrievalError"
        ></app-page-retrieval-error>
      </div>
      <div class="content-wrapper" *ngIf="!pageRetrievalError">
        <div class="separator"></div>
        <div class="generic-tabs-container">
          <app-generic-tabs
            [tabData]="tabs"
            (selectedTab)="onTabChanged($event)"
          ></app-generic-tabs>
        </div>

        <!-- HELPLINE SECTION -->
        <div
          class="helpline-content-container"
          *ngIf="selectedTabId.includes('helpline')"
        >
          <img
            class="mobile-background"
            [src]="
              wellbeingHelplineData.wellbeing_mobile_image.data?.attributes?.url
            "
          />
          <div #wellbeingHelpline class="wellbeing-helpline">
            <div #wellbeingComponent>
              <app-wellbeing-helpline></app-wellbeing-helpline>
            </div>
            <img
              #helplineImage
              [src]="
                wellbeingHelplineData.wellbeing_image.data?.attributes?.url
              "
            />
          </div>

          <div #coreServicesContainer class="core-services-container">
            <h2>{{ wellbeingHelplineData.title }}</h2>

            <div
              class="core-service"
              *ngFor="let service of wellbeingHelplineData.services"
            >
              <div class="core-service-text">
                <h4>{{ service.service_title }}</h4>
                <p>{{ service.service_description }}</p>
                <div class="separator"></div>
              </div>
            </div>
          </div>
        </div>

        <!-- MENTAL, FINANCIAL, PHYSICAL SECTIONS -->
        <div
          class="wellbeing-content-container"
          *ngIf="!selectedTabId.includes('helpline')"
        >
          <img
            class="mobile-background"
            [src]="wellbeingSectionInformation.image.data?.attributes?.url"
            alt=""
          />
          <div class="section-description">
            <h2>{{ wellbeingSectionInformation.title }}</h2>
            <app-render-markdown
              [content]="wellbeingSectionInformation.page_heading_description"
            ></app-render-markdown>
          </div>
          <div class="wellbeing-article-list" [ngClass]="gridClass">
            <div
              class="articles"
              *ngFor="let article of wellbeingArticlesToShow"
            >
              <div class="article-card-container">
                <div class="text-container">
                  <h2>{{ article.title }}</h2>
                  <p>{{ article.excerpt }}</p>
                </div>
                <button (click)="onArticlePressed(article)">
                  {{ article.cta_text ? article.cta_text : 'Read more' }}
                </button>
              </div>
            </div>
          </div>

          <div class="wellbeing-footer">
            <div class="flex-item">
              <img
                #wellbeingTabsImg
                [src]="
                  wellbeingSectionInformation?.image?.data?.attributes?.url
                "
              />
            </div>
            <div #infoCards class="info-cards flex-item">
              <app-wellbeing-helpline
                [alternateColours]="true"
              ></app-wellbeing-helpline>
              <app-signposting-card
                *ngIf="wellbeingSectionInformation?.show_signposting"
              ></app-signposting-card>
            </div>
          </div>
        </div>
      </div>
    </section>
  </ng-template>
</div>
